import {Injectable} from '@angular/core';
import {UnitType} from '../pipes/unit-parse.pipe';

@Injectable()
export class WitsService {
  constructor() {
    this.currentUnitType = this.unitTypes[0].name;
  }
  public units = [
    {
      id: 'm',
      measure: 'm',
      field: 'ft'
    },
    {
      id: UnitType.GallonsPerMin,
      measure: 'lpm',
      field: 'gpm'
    },
    {
      id: 'min',
      measure: 'min',
      field: 'min'
    },
    {
      id: 'C',
      measure: '°C',
      field: '°F'
    },
    {
      id: 'C/100m',
      measure: '°C/100m',
      field: '°F/100ft'
    },
    {
      id: 'tCoeff',
      measure: '1/°C',
      field: '1/°F'
    },
    {
      id: 'pCoeff',
      measure: '1/psi',
      field: '1/kPa'
    },
    {
      id: 'lpm',
      measure: 'lpm',
      field: 'gpm'
    },
    {
      id: 'm3/min',
      measure: 'm3/min',
      field: 'gpm'
    },
    {
      id: 'm/min',
      measure: 'm/min',
      field: 'ft/min'
    },
    {
      id: 'm/min/s',
      measure: '(m/min)/s',
      field: '(ft/min)/s'
    },
    {
      id: UnitType.Hours,
      measure: UnitType.Hours,
      field: UnitType.Hours
    },
    {
      id: UnitType.CubicMeter,
      measure: UnitType.CubicMeter,
      field: 'bbl'
    },
    {
      id: 'm3/stk',
      measure: 'm3/stk',
      field: 'bbl/stk'
    },
    {
      id: 'paSec_cp',
      measure: 'Pa-s',
      field: 'cP'
    },
    {
      id: 'cp*sn-1',
      measure: 'Pa*s<sup>n</sup>',
      field: 'cp*s<sup>n-1</sup>'
    },
    {
      id: 'W/mC',
      measure: 'W/m.°C',
      field: 'Btu/hr.ft.°F'
    },
    {
      id: 'j/kgC',
      measure: 'J/kg.°C',
      field: 'Btu/lb.°F'
    },
    {
      id: UnitType.KgPerM3,
      measure: UnitType.KgPerM3,
      field: 'ppg'
    },
    {
      id: 'kg/m',
      measure: 'kg/m',
      field: 'lb/ft'
    },
    {
      id: 'kPa/m',
      measure: 'kPa/m',
      field: 'psi/ft'
    },
    {
      id: UnitType.KPa,
      measure: UnitType.KPa,
      field: 'psi'
    },
    {
      id: 'mm',
      measure: 'mm',
      field: 'in'
    },
    {
      id: '1/32 mm',
      measure: 'mm',
      field: '1/32 in'
    },
    {
      id: 'rpm',
      measure: 'rpm',
      field: 'rpm'
    },
    {
      id: 'N-m',
      measure: 'N-m',
      field: 'klb-ft'
    },
    {
      id: 'NN-m',
      measure: 'N-m',
      field: 'lb-ft'
    },
    {
      id: 'daN',
      measure: 'daN',
      field: 'klbf'
    },
    {
      id: 'm/hr',
      measure: 'm/hr',
      field: 'ft/hr'
    },
    {
      id: 'mm2',
      measure: 'mm<sup>2</sup>',
      field: 'in<sup>2</sup>'
    },
    {
      id: 'Pa',
      measure: 'Pa',
      field: 'lb/100ft<sup>2</sup>'
    },
    {
      id: '%',
      measure: '%',
      field: '%'
    },
  ];
  public currentUnit = 'Depth';
  public currentUnitType;
  public unitTypes = [
    {
      id: '0',
      name: 'SI'
    },
    {
      id: '',
      name: 'Field'
    }
  ];

  public witUnits = [
    {
      unit: 'YYYY-MM-DD',
      unitGroup: '[\'YYYY-MM-DD\']'
    },
    {
      unit: 'hh:mm:ss',
      unitGroup: '[\'hh:mm:ss\']'
    },
    {
      unit: UnitType.Hours,
      unitGroup: '[\'hr\']'
    },
    {
      unit: 'ft',
      unitGroup: '[\'m\',\'ft\']'
    },
    {
      unit: 'm',
      unitGroup: '[\'m\',\'ft\']'
    },
    {
      unit: 'ft/hr',
      unitGroup: '[\'m/hr\',\'ft/hr\']'
    },
    {
      unit: 'kDaN',
      unitGroup: '[\'daN\', \'kDaN\',\'tonne\',\'lbf\',\'klbf\',\'ton\']'
    },
    {
      unit: 'N-m',
      unitGroup: '[\'N-m\',\'kgf-m\',\'lbf-ft\',\'klbf-ft\']'
    },
    {
      unit: 'rpm',
      unitGroup: '[\'rpm\']'
    },
    {
      unit: UnitType.KPa,
      unitGroup: '[\'kPa\',\'psi\',\'bar\',\'atm\',\'MPa\']'
    },
    {
      unit: 'spm',
      unitGroup: '[\'spm\']'
    },
    {
      unit: 'stk',
      unitGroup: '[\'stk\']'
    },
    {
      unit: 'm3/min',
      unitGroup: '[\'m3/min\',\'lit/min\',\'bbl/min\',\'ft3/min\', \'gpm\']'
    },
    {
      unit: 'm/hr',
      unitGroup: '[\'m/hr\',\'ft/hr\']'
    },
    {
      unit: 'daN',
      unitGroup: '[\'daN\', \'kDaN\', \'lbf\', \'klbf\']'
    },
    {
      unit: 'm3',
      unitGroup: '[\'m3\',\'bbl\']'
    },
    {
      unit: 'gpm',
      unitGroup: '[\'m3/min\',\'lit/min\',\'bbl/min\',\'ft3/min\', \'gpm\']'
    }
  ];

}
